module.exports = __webpack_public_path__ + "assets/img/busy_11.d0b36ee7.png";